export const CompanyNameTestID = 'CompanyName.TestID';
